import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { addToken, signIn, signOut } from "../store/slices/auth";
import axiosConfig from "../util/axios";
import requestErrorHandler from "../util/requestErrorHandler";

export default function useAuth() {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const token = localStorage.getItem("token");

  const logIn = useCallback(
    function (user: User | null, token?: string) {
      if (token) {  
        dispatch(addToken(token));
      }
      if (user) dispatch(signIn(user));
    },
    [dispatch]
  );

  const updateToken = useCallback(
    (token: string) => {
      dispatch(addToken(token));
    },
    [dispatch]
  );

  const getLoggedIn = useCallback(async (callback?:()=>void, _token?:string )=>{
    const mainToken  = token || _token
      try {
        if (mainToken ) {
          updateToken(mainToken);
          const res = await axiosConfig.get("/fleet/logged-in-profile");
          logIn(res.data.data);
          callback?.()
        } else {
          // logOut();
        }
      } catch (error) {
        requestErrorHandler(error)
        // logOut();
      }
    
  },[logIn, token, updateToken])

  const logOut = useCallback(() => {
    localStorage.clear();
    dispatch(signOut());
    window.location.href = "/"
  }, [dispatch]);

  return { user, logIn, logOut, updateToken,  token, getLoggedIn };
}